/* LabUserSessionAddon.js */

"use strict";
const LabUserSession = require("../LabUserSession");
class LabUserSessionAddon extends LabUserSession {
    constructor(logger, userFeedback, router, UserEntity) {
        super(logger, userFeedback, router, UserEntity);
    }
    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START OVERIDDEN METHODS */
    /*******************************************/

    /*******************************************/
    /* END OVERRIDEN METHODS */
    /* START STEVE ADD-ON METHODS              */
    /*******************************************/
    initialize() {
        //jshint ignore:line
    }
    startUp() {
        //jshint ignore:line
    }
    /*******************************************/
    /* END STEVE ADD-ON METHODS                */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER API METHODS */
    /*******************************************/
}
module.exports = LabUserSessionAddon;
module.exports.$inject = ["$teve.logger", "$teve.ui.userFeedback", "$teve.router", "$teve.user"];
